import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import ParticleField from "./ParticleField";

export default function CTASection() {
  return (
    <section className="relative bg-ink py-28 md:py-40 border-t border-slate-200 overflow-hidden" data-testid="cta-section">
      <ParticleField className="absolute inset-0 w-full h-full opacity-40" />
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-4xl sm:text-5xl lg:text-7xl font-black uppercase tracking-tighter leading-[0.95] max-w-5xl"
        >
          Ready to transform your{" "}
          <span className="text-brand">radiology workflow?</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="text-mute text-base md:text-lg leading-relaxed mt-8 max-w-xl"
        >
          Join leading healthcare institutions using AI-powered medical imaging.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="flex flex-wrap gap-3 mt-12"
        >
          <Link
            to="/register"
            data-testid="cta-get-started-button"
            className="flex items-center gap-2 bg-brand text-white font-mono text-xs uppercase tracking-[0.15em] px-8 py-4 rounded-full hover:bg-[#0F172A] hover:text-white transition-colors duration-300"
          >
            Get started <ArrowUpRight className="w-4 h-4" />
          </Link>
          <a
            href="#contact"
            data-testid="cta-contact-button"
            className="flex items-center gap-2 bg-white border border-slate-300 text-slate-900 font-mono text-xs uppercase tracking-[0.15em] px-8 py-4 rounded-full hover:border-[#0F172A] hover:bg-[#0F172A] hover:text-white transition-[background-color,color,border-color] duration-300"
          >
            Talk to our team
          </a>
        </motion.div>
      </div>
    </section>
  );
}
